import { BaseService } from "services/_baseService";

class MembersAdminService extends BaseService<any> {
  constructor() {
    super(`members`);
  }
}

export default new MembersAdminService();
